var p = Object.defineProperty, x = Object.defineProperties;
var A = Object.getOwnPropertyDescriptors;
var d = Object.getOwnPropertySymbols;
var M = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var g = (l, c, r) => c in l ? p(l, c, { enumerable: !0, configurable: !0, writable: !0, value: r }) : l[c] = r, t = (l, c) => {
  for (var r in c || (c = {}))
    M.call(c, r) && g(l, r, c[r]);
  if (d)
    for (var r of d(c))
      v.call(c, r) && g(l, r, c[r]);
  return l;
}, n = (l, c) => x(l, A(c));
var w = (l, c) => {
  var r = {};
  for (var a in l)
    M.call(l, a) && c.indexOf(a) < 0 && (r[a] = l[a]);
  if (l != null && d)
    for (var a of d(l))
      c.indexOf(a) < 0 && v.call(l, a) && (r[a] = l[a]);
  return r;
};
import { jsx as o } from "react/jsx-runtime";
import z from "react";
import { r as s } from "../../rem-CMQJ_ZTp.js";
const L = z.forwardRef((f, h) => {
  var e = f, { ariaHidden: l = "true", color: c, filled: r = !1, size: a = 16, style: i } = e, m = w(e, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ o(
    "svg",
    n(t({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": l,
      color: c,
      ref: h,
      role: "img",
      style: t({ width: s(a), height: s(a) }, i)
    }, m), {
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: r ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" : "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
      )
    })
  );
}), R = z.forwardRef((f, h) => {
  var e = f, { ariaHidden: l = "true", color: c, filled: r = !1, size: a = 16, style: i } = e, m = w(e, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ o(
    "svg",
    n(t({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": l,
      color: c,
      ref: h,
      role: "img",
      style: t({ width: s(a), height: s(a) }, i)
    }, m), {
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: r ? "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" : "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"
        }
      )
    })
  );
}), y = z.forwardRef((f, h) => {
  var e = f, { ariaHidden: l = "true", color: c, filled: r = !1, size: a = 16, style: i } = e, m = w(e, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ o(
    "svg",
    n(t({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": l,
      color: c,
      ref: h,
      role: "img",
      style: t({ width: s(a), height: s(a) }, i)
    }, m), {
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: r ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" : "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
        }
      )
    })
  );
}), B = z.forwardRef((f, h) => {
  var e = f, { ariaHidden: l = "true", color: c, filled: r = !1, size: a = 16, style: i } = e, m = w(e, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ o(
    "svg",
    n(t({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": l,
      color: c,
      ref: h,
      role: "img",
      style: t({ width: s(a), height: s(a) }, i)
    }, m), {
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: r ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" : "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
      )
    })
  );
});
export {
  y as CircleExclamationFarFAIcon,
  L as CircleInfoFarFAIcon,
  B as CircleXmarkFarFAIcon,
  R as TriangleExclamationFarFAIcon
};
